import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { FormItem } from "azure-devops-ui/FormItem";
import { TextField, TextFieldWidth } from "azure-devops-ui/TextField";

const errorObservable = new ObservableValue<string>("");

export default class MessageTextFieldExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <FormItem message="This is a message" error={true}>
                <TextField
                    ariaLabel="Aria label"
                    value={errorObservable}
                    onChange={e => (errorObservable.value = e.target.value)}
                    width={TextFieldWidth.standard}
                />
            </FormItem>
        );
    }
}
